
<table [style.margin-left.cm]="RXMarginLayoutLeft"
       [style.margin-right.cm]="RXMarginLayoutRight"
       [style.margin-top.cm]="RXMarginLayoutTop"
       [style.margin-bottom.cm]="RXMarginLayoutBottom"
       [style.width.%]="RXA5width">
       
  <thead>
    <tr class="border-bottom-0px">
      <td>
        <div class="printheader-space"
             [style.height.px]="RXPrintHeaderHeight">&nbsp;</div>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.css">
        <style>
          @page {
            size: 7.5in 6in
          }
        </style>
      </td>
    </tr>
  </thead>
  <tbody>
    <tr class="border-bottom-0px">
      <td>
        <div class="content">          
            <router-outlet></router-outlet>
            <router-outlet name="print"></router-outlet>
            <!--<section class="sheet"></section>-->
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="border-bottom-0px">
      <td>
        <div class="printfooter-space"
             [style.height.px]="RXPrintFooterHeight">&nbsp;</div>
             
      </td>
    </tr>
  </tfoot>
</table>




<div>

  <div class="printheader" *ngIf="ShowRXPrintHeaderLogoCustomer == 'true'"
       [style.height.px]="RXPrintHeaderHeight">
    <div class="card borderbot5px background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        <div class="col-print-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-print-2 padding-left-0px padding-right-0px">
              <img [src]="RXlogo"
                   [style.width.px]="PrintlogoWidth"
                   [style.height.px]="PrintlogoHeight"
                   [style.border-radius.%]="PrintlogoBorderRadius"
                   class="">
            </div>

            <div class="col-print-5">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{RXHeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{RXHeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{RXHeaderSubTitle1}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RXHeaderSubTitle1Value}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{RXHeaderSubTitle2}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RXHeaderSubTitle2Value}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-5 padding-right-5px border-color-blue" *ngIf="CurrentX_BillHeaderController">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{CurrentX_BillHeaderController.PatientName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngIf="!CurrentX_BillHeaderController.IsGuest">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{CurrentX_BillHeaderController.PatientFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngIf="CurrentX_BillHeaderController.IsGuest">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : </label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{CurrentX_BillHeaderController.PatientGender}}/{{CurrentX_BillHeaderController.PatientAge}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{CurrentX_BillHeaderController.PatientTelephoneNumber1}}</label>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">

      </div>

    </div>
  </div>

  <div class="printheader" *ngIf="ShowRXPrintHeaderLogo == 'true'"
       [style.height.px]="RXPrintHeaderHeight">
    <div class="card borderbot5px background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        <div class="col-print-12 padding-left-0px">
          <div class="row margin-left-0px">
            <div class="col-print-2 padding-left-0px padding-right-0px">
              <img [src]="RXlogo"
                   [style.width.px]="PrintlogoWidth"
                   [style.height.px]="PrintlogoHeight"
                   [style.border-radius.%]="PrintlogoBorderRadius"
                   class="">
            </div>

            <div class="col-print-5">
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-familysubhead">{{RXHeaderLine1}}</label>
              </div>
              <div class="row margin-left-0px">
                <label class="margin-bottom-0px font-weight-normal font-family">{{RXHeaderLine2}}</label>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{RXHeaderSubTitle1}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RXHeaderSubTitle1Value}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{RXHeaderSubTitle2}}</label>
                </div>
                <div class="col-print-10">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RXHeaderSubTitle2Value}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-5 padding-right-5px border-color-blue" *ngIf="CurrentX_BillHeaderController">
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Customer Details</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead float-right font-weight-bold font-color-blue">{{CurrentX_BillHeaderController.PatientName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngIf="!CurrentX_BillHeaderController.IsGuest">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : {{CurrentX_BillHeaderController.PatientFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px" *ngIf="CurrentX_BillHeaderController.IsGuest">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal font-color-blue">ID : </label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">Sex/Age : {{CurrentX_BillHeaderController.PatientGender}}/{{CurrentX_BillHeaderController.PatientAge}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-5px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal"><i class="fas fa-phone"></i> : {{CurrentX_BillHeaderController.PatientTelephoneNumber1}}</label>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="card-body padding-top-0px padding-bottom-0px">

      </div>

    </div>
  </div>

  <div class="printheader" *ngIf="RXPrintHeaderEmpty == 'true'"
       [style.height.px]="RXPrintHeaderHeight">

  </div>

  <div class="printfooter" *ngIf="ShowRXPrintFooter == 'true'">


    <div class="card footerborder-top">

      <div class="card-header border-bottom-0px padding-bottom-0px padding-top-5px padding-left-0px padding-right-0px">

      </div>
      <div class="card-body padding-top-0px padding-bottom-0px background-color-wt padding-left-0px">
        <div class="row margin-left-0px margin-right-5px">

          <div class="col-print-8 footerborder-right padding-left-5px padding-right-5px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{RXHeaderFooterLine1}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">{{RXHeaderFooterLine2}}</label>
            </div>

          </div>

          <div class="col-print-3 padding-left-0px padding-right-0px"></div>

          <div class="col-print-1 padding-left-0px padding-right-0px">

            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-weight-normal font-family">
                <qrcode class="padding-top-0px padding-bottom-0px" [qrdata]="BillNumber" [size]="90" [level]="'M'"></qrcode>
              </label>
            </div>

          </div>

        </div>
        <!--<div class="row">
          <div class="col-md-9">

          </div>
          <div class="col-md-3">
            <label class="margin-bottom-0px font-family13px">Print Taken: {{Date | date:'dd-MMM-yyyy'}}</label>
          </div>
        </div>-->
        <!--<div class="row">
          <div class="col-print-9">

          </div>
          <div class="col-print-3">
            <label class="margin-bottom-0px font-family13px footer_info_Mh"></label>
          </div>
        </div>-->
      </div>

    </div>

  </div>

  <div class="printfooter" *ngIf="ShowRXPrintFooterEmpty == 'true'">


  </div>

</div>
